import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'StratMech Studios';
const BASE_URL = 'https://stratmechstudios.com';
const DEFAULT_OG_IMAGE = `${BASE_URL}/images/webp/BoxFront_1045x820.webp`;

/**
 * Reusable per-page SEO head tags via react-helmet-async.
 *
 * Usage:
 *   <PageMeta
 *     title="Page Title | StratMech Studios"
 *     description="Page-specific description."
 *     path="/some-page"
 *   />
 */
export default function PageMeta({
  title,
  description,
  path = '/',
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  noindex = false,
  children,
}) {
  const canonical = `${BASE_URL}${path}`;
  const resolvedOgTitle = ogTitle || title;
  const resolvedOgDescription = ogDescription || description;
  const resolvedOgImage = ogImage || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {!noindex && <link rel="canonical" href={canonical} />}
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow,max-image-preview:large" />
      )}

      {/* Open Graph */}
      <meta property="og:locale" content="en_IN" />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={resolvedOgTitle} />
      <meta property="og:description" content={resolvedOgDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={resolvedOgImage} />
      <meta property="og:image:width" content="776" />
      <meta property="og:image:height" content="629" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedOgTitle} />
      <meta name="twitter:description" content={resolvedOgDescription} />
      <meta name="twitter:image" content={resolvedOgImage} />

      {children}
    </Helmet>
  );
}
